"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageSession = void 0;
// eslint-disable-next-line camelcase
var jwt_decode_1 = __importDefault(require("jwt-decode"));
// todo: change file name
var LocalStorageSession = /** @class */ (function () {
    function LocalStorageSession(localStorage) {
        this.localStorage = localStorage;
    }
    // eslint-disable-next-line class-methods-use-this
    LocalStorageSession.prototype.set = function (session) {
        this.localStorage.setItem('authJwtToken', session.token);
    };
    // eslint-disable-next-line class-methods-use-this
    LocalStorageSession.prototype.getJWTToken = function () {
        var JWTStr = this.localStorage.getItem('authJwtToken');
        if (!JWTStr) {
            return null;
        }
        try {
            var jwt = (0, jwt_decode_1.default)(JWTStr);
            return __assign(__assign({}, jwt), { token: JWTStr });
        }
        catch (e) {
            return null;
        }
    };
    LocalStorageSession.prototype.logout = function () {
        this.localStorage.clear();
    };
    return LocalStorageSession;
}());
exports.LocalStorageSession = LocalStorageSession;
//# sourceMappingURL=sessionService.js.map